var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.411394 10.4133C0.0859571 10.7388 0.0859571 11.2664 0.411394 11.5919C0.736831 11.9173 1.26447 11.9173 1.58991 11.5919L6.58991 6.59186C6.90539 6.27638 6.91643 5.76839 6.61495 5.4395L2.03161 0.4395C1.72062 0.100234 1.19348 0.0773153 0.854212 0.388309C0.514946 0.699303 0.492028 1.22644 0.803021 1.56571L4.8472 5.97754L0.411394 10.4133Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.f4c629758a9905f24867d6c913d5b387.svg";
export { ForwardRef as ReactComponent };